import React from 'react';
import { Dialog } from '@mui/material';
import AddCustomer from './AddCustomer';
import EditCustomer from './EditCustomer';

const CustomerToggleModal = ({
  open,
  toggle,
  isEdit,
  getData,
  data,
  length,
  segmentId,
  countries,
  segmentName,
  setSnackBarOpen,
  setSnackbarSeverity,
  setSnackBarMessage,
}) => {
  return (
    <Dialog
      open={open}
      keepMounted
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      {!isEdit && (
        <AddCustomer
          toggle={toggle}
          open={open}
          getData={getData}
          length={length}
          segmentId={segmentId}
          countries={countries}
          segmentName={segmentName}
          setSnackBarOpen={setSnackBarOpen}
          setSnackbarSeverity={setSnackbarSeverity}
          setSnackBarMessage={setSnackBarMessage}
        />
      )}
      {isEdit && (
        <EditCustomer
          toggle={toggle}
          open={open}
          data={data}
          getData={getData}
          segmentId={segmentId}
          countries={countries}
          setSnackBarOpen={setSnackBarOpen}
          setSnackbarSeverity={setSnackbarSeverity}
          setSnackBarMessage={setSnackBarMessage}
        />
      )}
    </Dialog>
  );
};

export default CustomerToggleModal;
